import React from 'react';
import { textUtils } from '@instinet-analytics/core-lib';
import 'utils/components/RevisionNumber/RevisionNumber.scss';

const { pluralise } = textUtils;

interface RevisionLabelProps {
    endIndex: number;
}

export default function RevisionLabel(props: RevisionLabelProps) {
    const { endIndex } = props;

    const pageCount = endIndex + 1;

    return (
        <div className="RevisionNumber label">
            {pluralise(pageCount, 'Revision')}
        </div>
    );
}
